var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown',{staticClass:"d2-mr",attrs:{"size":"small"}},[_c('span',{staticClass:"btn-text"},[_vm._v("\n    当前账套: "+_vm._s(_vm.account.name)+" "+_vm._s(_vm.account.currentYear)+"年第"+_vm._s(_vm.account.currentMonth)+"期\n  ")]),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }